var _style, _rect, _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgrWavesMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 1339",
    style: {
      enableBackground: "new 0 0 320 1339"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#17202A;}\n\t.st1{opacity:0.3;clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st2{opacity:0.15;clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st3{opacity:0.15;clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 320,
    height: 1339
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 320,
    height: 1339
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.0526,
    y1: -198.542,
    x2: 342.8392,
    y2: 404.6403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0969,
    style: {
      stopColor: "#803D25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.65,396.05c-143,30.11-288.79-54.68-321.99-179.99C53.01,77.78,194.63,26.8,247.4,30.95 c67.09,5.28,172.21,17.95,219.53-54.79c72.62-111.62,155.7-165.51,219.19-95.5c57.79,63.72,43.57,166.81,20.6,238.47 C670.41,232.38,554.65,365.93,411.65,396.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.7052,
    y1: 245.432,
    x2: 65.4886,
    y2: 747.881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#305299"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4107,
    style: {
      stopColor: "#253D6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-181.21,659.36c-105.6-101.01-117.95-269.21-33.29-367.38c93.42-108.32,215.47-20.23,241.84,25.65 c33.53,58.35,82.44,152.26,169.19,150.24c133.12-3.1,224.52,35.03,202.6,126.97C379.16,678.52,286.06,725,213.94,746.51 C99.98,780.5-75.61,760.37-181.21,659.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1675.933,
    y1: 2283.6084,
    x2: 1283.6675,
    y2: 1897.2563,
    gradientTransform: "matrix(0.7274 0.6862 -0.6862 0.7274 522.6373 -1546.0472)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#574B37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17202A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.23,1240.54c-145.37-14.9-258.39-140.08-251.83-269.55c7.24-142.86,157.66-148.26,206.64-128.22 c62.29,25.47,158.55,69.57,225.78,14.72C357,773.3,452.56,747.29,491.7,833.32c35.62,78.3-9.33,172.15-53.05,233.41 C369.56,1163.52,218.6,1255.44,73.23,1240.54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgrWavesMobile);
export default __webpack_public_path__ + "static/media/bgr_waves_mobile.2a6c9e2393ceaa94fb9af6d8bd7f1090.svg";
export { ForwardRef as ReactComponent };